import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Image } from 'rebass'
import { css } from 'styled-components'
import { ImageRatio } from './styles'
import { ColorOverlay } from '../../components/ui/ColorOverlay'
import { RichText } from '../../components/RichText'
import Layout from '../../components/layout'
import { Bold, Paragraph, Heading } from '../../components/Text'
import SEO from '../../components/seo'

const get = (obj, path, defaultValue) =>
  path.split('.').reduce((a, c) => (a && a[c] ? a[c] : defaultValue || null), obj)

const Artist = ({ pageContext }) => {
  const {
    description,
    seo,
    image: {
      fluid: { src, srcSet, sizes },
    },
  } = pageContext
  const { description: seoDesc } = seo.description || {}
  return (
    <Layout invertMenuLogo>
      <SEO
        title={pageContext.name}
        description={seoDesc || ''}
        keywords={seo.keywords || []}
        image={get(seo.image, 'resize.src', undefined)}
      />
      <Box
        width={[1, 1]}
        mx={[0, 0, 'auto']}
        color="white"
        p={[0, 0, 5]}
        pb={[6, 6, 5]}
        css={css`
          max-width: 1400px;
          z-index: 1;
          position: relative;
        `}
      >
        <Flex flexDirection={['column', 'column', 'row']} justifyContent="space-between">
          <Box width={['auto', 'auto', 1 / 2, 2 / 5]} mt={[0, 0, 4]} mx={[-3, -3, 0]}>
            <ImageRatio>
              <Image width={1} src={src} srcSet={srcSet} sizes={sizes} alt={pageContext.name} />
            </ImageRatio>
          </Box>
          <Box ml={[4, 5, 5]} width={['auto', 'auto', 1 / 2, 2 / 5]}>
            <Heading as="h1">{pageContext.name}</Heading>
            <RichText
              BOLD={text => <Bold>{text}</Bold>}
              PARAGRAPH={(_, children) => <Paragraph>{children}</Paragraph>}
              A={(node, children) => (
                <Bold
                  as="a"
                  href={node.data.uri}
                  css={css`
                    color: inherit;
                    display: block;
                    text-decoration: underline;
                    text-transform: uppercase;
                  `}
                >
                  {children}
                </Bold>
              )}
              HEADING={(children, { level }) => <Heading as={`h${level}`}>{children}</Heading>}
              document={description.description}
            />
          </Box>
        </Flex>
      </Box>
      <ColorOverlay />
    </Layout>
  )
}

Artist.propTypes = {
  pageContext: PropTypes.object.isRequired,
}

export default Artist
